import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
const MobileDevPageSide300x250 = /*#__PURE__*/ React.memo(({ safety ='off' , safetyState  })=>{
    const _useAdUnit = useAdUnit(AdProviders.Hashtag, ADUNIT_MAP['UserMobileDevPageSide300x250Gam'], safety, safetyState, {
        targeting: {
            unitType: 'btf'
        }
    }), { advertIsOff  } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff === 'off') {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, adunitMemo);
MobileDevPageSide300x250.displayName = 'MobileDevPageSide300x250';
export default MobileDevPageSide300x250;
